import React from "react";
import { Checkbox, SelectField, MenuItem } from "material-ui";

/**
 * @param {{ 
 *      setApprovedFilter: Function,
 *      approved: boolean,
 * }} ApprovedRejected
 */
export default function ApprovedRejected({ approved, setApprovedFilter }) {
    return (
        <div 
            id='filters--approved'
        >
            <SelectField
                value={approved}
                labelStyle={{ fontSize: '13px' }}
                floatingLabelStyle={{ display: 'none' }}
                errorStyle={{ display: 'none' }}
                onChange={(_e, _i, v) => setApprovedFilter(v)}
                fullWidth
            >
                <MenuItem value={null} primaryText='All' />
                <MenuItem value={true} primaryText='Approved' />
                <MenuItem value={false} primaryText='Not Approved' />
            </SelectField>
        </div>
    );
}



// WEBPACK FOOTER //
// ./app/components/Vessels/Composition/ApprovedRejected.jsx